import { render, staticRenderFns } from "./VantActivityAlwaysDiscountPop.vue?vue&type=template&id=f8d221de&"
import script from "./VantActivityAlwaysDiscountPop.vue?vue&type=script&lang=js&"
export * from "./VantActivityAlwaysDiscountPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports